import React from "react";
import { Button, Box } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useIsDesktop } from "./hooks/useIsDesktop";

/**
 * 共通アクションボタン
 * - 左に白丸アイコン
 * - 右に >（任意）
 * - ピル型・立体ボタン
 * - 色味は呼び出し側で制御する
 */
export default function ActionButton({
  onClick,
  label,
  icon,
  showArrow = false,
  showBadge = false,
  badgeText = "未入力あり",
  sx = {}, // スタイルを外から受け取る
  badgeSx = {}, // バッチのスタイルを外から受け取る
}) {
  const isDesktop = useIsDesktop();
  return (
    <Button
      onClick={onClick}
      sx={{
        position: "relative",
        height: 40,
        width: isDesktop ? 240 : "100%",
        borderRadius: "999px",
        whiteSpace: "nowrap",

        pr: showArrow ? (isDesktop ? 7 : 5) : isDesktop ? 6 : 3.5,
        pl: icon ? (isDesktop ? 8 : 5.5) : isDesktop ? 6 : 3.5,

        color: "#fff",
        fontWeight: 600,
        fontSize: "0.9rem",
        boxShadow: 4,
        transition: "all 0.15s ease",

        // テキストを中央寄せ
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        "&:hover": {
          boxShadow: "none",
        },

        ...sx,
      }}
    >
      {/* 左固定のアイコン（ある時だけ描画） */}
      {icon && (
        <Box
          sx={{
            position: "absolute",
            left: 6,
            width: 30,
            height: 30,
            borderRadius: "50%",
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}
        </Box>
      )}

      {/* 未入力バッジ */}
      {showBadge && (
        <Box
          sx={{
            position: "absolute",
            top: "-10px",
            right: "-6px",
            color: "#fff",
            fontSize: isDesktop ? "0.65rem" : "0.55rem",
            px: isDesktop ? 1 : 0.6,
            py: "1px",
            borderRadius: "999px",
            fontWeight: "bold",
            boxShadow: 1,
            ...badgeSx,
          }}
        >
          {badgeText}
        </Box>
      )}
      {label}

      {/* 右矢印 */}
      {showArrow && (
        <Box
          sx={{
            position: "absolute",
            right: 10,
            display: "flex",
            alignItems: "center",
            color: "inherit",
            opacity: 0.9,
          }}
        >
          <ChevronRightIcon sx={{ fontSize: 16 }} />
        </Box>
      )}
    </Button>
  );
}
